<div class="divisa-col-sm-12 my-auto only">
  <!-- Estado de carga -->
  <div class="card border-success" *ngIf="loading">
    <div class="card-body text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'PERFIL.LOADING_ARIA' | translate }}</span>
      </div>
      <p class="mt-2">{{ 'PROFILE_PAGE.BRANCH_LOADING' | translate }}</p>
    </div>
  </div>

  <!-- Sucursal cargada -->
  <div class="card border-success" *ngIf="!loading && sucursal">
    <div class="card-header">
      <div class="divisa-row my-auto py-2">
        <div class="divisa-col-10 my-auto">
          <h6 class="mb-0">
            {{ 'PROFILE_PAGE.PREFERRED_BRANCH_TITLE' | translate }}
          </h6>
        </div>
        <div class="ml-auto">
          <button
            mat-mini-fab
            [matTooltip]="'PROFILE_PAGE.EDIT_BRANCH_TOOLTIP' | translate"
            color="accent"
            (click)="selectSucursal()"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
        </div>
      </div>
      <span class="subtitulo text-color-primary"
        >{{ sucursal.branchName || sucursal.name }} -
        {{ sucursal.address?.locality }}</span
      >
    </div>
    <div class="">
      <div #map style="width: 100%; height: 198px"></div>
    </div>
    <div class="card-footer divisa-row">
      <img
        class="divisa-col-2 my-auto"
        style="max-width: 40px; max-height: 40px"
        src="./assets/img/circle-icon.svg"
        alt=""
      />
      <p class="divisa-col-10 pl-3 my-auto my-mb-0">
        {{ sucursal.address.street }}, {{ sucursal.address.zipCode }},
        {{ sucursal.address.state }}
      </p>

      <div class="divisa-col-8 divisa-space-between mx-auto my-2">
        <a
          mat-fab
          [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_PHONE' | translate"
          color="accent"
          class="icon-sm-button"
          href="tel:{{ sucursal.address.phone }}"
        >
          <i class="fa-solid fa-phone" style="font-size: 23px"></i>
        </a>
        <a
          mat-fab
          [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_WHATSAPP' | translate"
          color="accent"
          class="icon-sm-button"
          target="_blank"
          href="https://wa.me/{{ sucursal.address.whatsapp }}"
        >
          <i class="fa-brands fa-whatsapp" style="font-size: 23px"></i>
        </a>
        <a
          mat-fab
          [matTooltip]="'PROFILE_PAGE.TOOLTIP_MAP' | translate"
          color="accent"
          class="icon-sm-button"
          target="_blank"
          href="https://www.google.com/maps/search/?api=1&query={{
            sucursal.address.latitude
          }}%2C{{ sucursal.address.longitude }}"
        >
          <i class="fa-solid fa-location-dot" style="font-size: 23px"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- Sin sucursal -->
  <div class="card border-warning" *ngIf="!loading && !sucursal">
    <div class="card-body text-center py-4">
      <mat-icon
        color="warn"
        style="font-size: 48px; width: 48px; height: 48px"
        svgIcon="location_off"
      ></mat-icon>
      <h6 class="mt-2">
        {{ 'PROFILE_PAGE.BRANCH_EMPTY_TITLE' | translate }}
      </h6>
      <p class="text-muted">
        {{ 'PROFILE_PAGE.BRANCH_EMPTY_TEXT' | translate }}
      </p>
      <button mat-raised-button color="accent" (click)="selectSucursal()">
        {{ 'PROFILE_PAGE.SELECT_BRANCH_BUTTON' | translate }}
      </button>
    </div>
  </div>
</div>
